import { Component, OnDestroy} from '@angular/core';
import { ModalService } from '@ibe/services/ui';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CybersourceModalService } from '@ibe.services/cybersource-modal.service';
import { INDRAPaymentService } from '@ibe.services/payment.indra.service';
// import { INDRABookingPaymentPageComponent } from '../booking-payment-page/booking-payment-page.indra.component';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { Router } from '@angular/router';

import { 
		PAYMENT_FLOW_MYB,
		PAYMENT_FLOW_BOOKING,
		PAYMENT_CARDHOLDER_TRAVELLING,
		PAYMENT_CARDHOLDER_NOT_TRAVELLING,
		PAYMENT_NOTIFICATION_ERROR_CODE_DECLINED_CC_VALIDATION
} from '@ibe.config';


@Component({
	selector: 'app-cybersource-modal',
	templateUrl: './cybersource-modal.indra.component.html',
	styleUrls: ['./cybersource-modal.component.scss']
})
export class INDRACybersourceModalComponent extends AbstractModalContentComponent implements OnDestroy {

	public resultOfPayment: any;
	private dataPay: any;
	private currentDataPay = new BehaviorSubject(this.dataPay);
	public msgTwo = false;
	public msgOne = false;
	private card_number: string;
	public acceptButtonEnabled = true;
	private isBookingFlow: boolean = false;

	allSubscriptions: Subscription[] = [];
	cyberSourceModalSubscription: Subscription;

	constructor(
		protected modalService: ModalService,
		private cybersourceModalService: CybersourceModalService,
		private storage: INDRAStorageService,
		private paymentService: INDRAPaymentService,
		protected router: Router
	) {
		super(modalService);
		this.TYPE = 'dialog';
	}

	ngOnInit() {
		this.INDRA_fraudMessage();
	}

	/**
	 * NOTE: booking-payment-page component must subscribe to cybersourceModalService to prevent circular dependecies
	 * Parameters being passed to modal: 
	 *	(0) dataPay
	 *	(1) idOperation
	 * 	(2) fraud message code (MSG1 or MSG2)
	 *	(3) card number
	 *	(4) payment flow (PAYMENT_FLOW_MYB, or PAYMENT_FLOW_BOOKING)
	 */
	INDRA_cyberSourceAccept() {
		const dataPayment = this.modalService.params[0];
		const idOperation = this.modalService.params[1];
		const fraudType = this.modalService.params[2];
		this.isBookingFlow = true;
		// const component:INDRABookingPaymentPageComponent = this.modalService.params[3]; 
		// const card_number: string = this.modalService.params[4];
		this.acceptButtonEnabled = false;
		this.cybersourceModalService.sendDataPayment(dataPayment, idOperation, fraudType);
		this.cyberSourceModalSubscription = this.cybersourceModalService.getObject().subscribe(res => {
			this.closeModal();
		});
	}

	INDRA_cyberSourceReject() {
		// const component: INDRABookingPaymentPageComponent = this.modalService.params[3];
		const pnr = this.modalService.params[0].pnr;
		const lastname = this.storage.get('lastname');
		const paymentFlow = this.modalService.params[4];
		this.closeModal();
		// note: no redirection needed for Normal IBE booking and TTT payment flow
		if (paymentFlow === PAYMENT_FLOW_MYB) {
			this.router.navigate(['/my-bookings/details', pnr, lastname]);
		} else if (paymentFlow === PAYMENT_FLOW_BOOKING) {
			const request = {
				sessionId: this.storage.get('token'),
				pnr: pnr,
				idOperation: this.modalService.params[1],
				typeError: PAYMENT_NOTIFICATION_ERROR_CODE_DECLINED_CC_VALIDATION
			}
			this.paymentService.INDRA_declinedValidation(request);
			this.router.navigate(['/']);
		}
	}

	INDRA_fraudMessage() {
		const message = this.modalService.params[2];

		if (message === PAYMENT_CARDHOLDER_TRAVELLING) {
			this.msgOne = true;
		} else if (message === PAYMENT_CARDHOLDER_NOT_TRAVELLING) {
			this.msgTwo = true;
		}
	}

	closeModal() {
		this.modalService.close();
	}

	ngOnDestroy() {
		for (let sub of this.allSubscriptions) {
			if (sub) {
				sub.unsubscribe();
			}
		}
	}

}
